<div class="rich-text-editor" [ngClass]="{ disabled: formControl.disabled, error: formControl.invalid }">
  @if (label) {
    <label class="rich-text-editor__label">
      @if (formControl.invalid) {
        <span class="icon-circle-information" sag-ui-tooltip [tooltip]="'report.errors.exceededTextMaxLength' | translate: { maxLength }"></span>
      }
      {{ label }}
      @if (!required) {
        <sup> (optional)</sup>
      }
    </label>
  }
  <div class="NgxEditor__Wrapper">
    @if (formControl.enabled) {
      <ngx-editor-menu [editor]="editor" [toolbar]="toolbarConfig" [colorPresets]="colorPresetsConfig" />
    }
    <ngx-editor [formControl]="formControl" [ngClass]="{ disabled: formControl.disabled }" [editor]="editor" [placeholder]="placeholder" outputFormat="html" />
  </div>

  @if (!disabled) {
    <div class="rich-text-editor__hint">
      @if (maxLength) {
        <span class="icon-circle-information">
          {{ "editor.hints.maxLength" | translate: { maxLength } }}
        </span>
      }
      <span class="icon-circle-information">
        {{ "editor.hints.noImagesOrFiles" | translate }}
      </span>
    </div>
  }
</div>
